import React, { useState } from 'react';
import '../../entrydoor.css';

const Swing = ({ value, onChange, label = 'Swing:', disabled = false }) => {
    const [selectedSwing, setSelectedSwing] = useState(value || "Inswing");
    const [labelText, setSelectedLabelText] = useState('Swing');

    const visibleShapes = ['Inswing'];

    const handleSwingChange = (e) => {
        const newValue = e.target.value;
        setSelectedSwing(newValue);
        setSelectedLabelText('Outwing No Tilt Option');
        if (e.target.value == "Inswing"){
            setSelectedLabelText('Swing');

            const element = document.getElementById("DecorativeTips");
            if (element){
                element.style.display = visibleShapes.includes(newValue) ? "none" : "block";
                const label = element.previousElementSibling; // Fetch the label,block if present
                if (label) {
                    label.style.display = visibleShapes.includes(newValue) ? "none" : "block";
                }
            }
        }
        else{
            const element = document.getElementById("DecorativeTips");
            if (element){
                element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                const label = element.previousElementSibling; // Fetch the label,block if present
                if (label) {
                    label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                }
            }
        }
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="Swing">{labelText}</label>
            <select
                disabled={disabled}
                id="Swing"
                value={selectedSwing}
                onChange={handleSwingChange}
            > 
               <option value="Inswing">{selectedSwing === "Inswing" ? "Inswing ✔" : "Inswing"}</option>
               <option value="Outswing">{selectedSwing === "Outswing" ? "Outswing ✔" : "Outswing"}</option>
            </select>
        </div>
    );
};

export default Swing;
